<form nz-form #f="ngForm" se-container gutter="32" (ngSubmit)="submitForm()">
  <se label="Identifikator">
    <input type="text" nz-input [(ngModel)]="identifier" name="identifier" required pattern="^[a-z_0-9]*$" placeholder="identifier" />
  </se>
  <se>
    <button nz-button nzType="primary" [disabled]="f.invalid">Erstellen</button>
  </se>
</form>
